import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, LogOut, User, Users, Shield, Truck, ChevronDown } from "lucide-react";
import { useAuth } from "@/context/AuthProvider";

export const LoginMenu = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const nav = useNavigate();

  useEffect(() => {
    const on = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", on);
    return () => document.removeEventListener("mousedown", on);
  }, []);

  if (user && user.role) {
    const roleHome = { admin: "/admin", employee: "/employee", customer: "/account" }[user.role] || "/";
    return (
      <div className="relative" ref={ref}>
        <button
          onClick={() => setOpen((o) => !o)}
          data-testid="user-menu-btn"
          className="flex items-center gap-2 text-sm text-[#F6F1E4] hover:text-[#FFD166] transition-colors px-3 py-1.5 rounded-full border border-[#FFD166]/25"
        >
          <User className="w-4 h-4" />
          <span className="hidden md:inline">{user.name?.split(" ")[0] || user.email}</span>
          <ChevronDown className="w-3.5 h-3.5" />
        </button>
        {open && (
          <div className="absolute right-0 mt-2 w-56 bg-[#0F1E2C] border border-[#FFD166]/30 rounded-xl shadow-2xl overflow-hidden z-50" data-testid="user-menu-dropdown">
            <div className="px-4 py-3 border-b border-[#FFD166]/15">
              <div className="text-sm text-[#F6F1E4]">{user.name}</div>
              <div className="text-xs text-[#B9C8D5]">{user.email}</div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-[#FFD166] mt-1">{user.role}</div>
            </div>
            <button onClick={() => { setOpen(false); nav(roleHome); }} className="w-full text-left px-4 py-2.5 text-sm text-[#F6F1E4] hover:bg-[#FFD166]/10" data-testid="user-menu-dashboard">
              My {user.role === "customer" ? "Bookings" : "Dashboard"}
            </button>
            <button onClick={async () => { await logout(); setOpen(false); nav("/"); }} className="w-full text-left px-4 py-2.5 text-sm text-red-300 hover:bg-red-500/10 flex items-center gap-2" data-testid="user-menu-logout">
              <LogOut className="w-4 h-4" /> Log out
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="login-menu-btn"
        className="flex items-center gap-2 text-sm text-[#F6F1E4] hover:text-[#FFD166] transition-colors px-3 py-1.5 rounded-full border border-[#FFD166]/25"
      >
        <LogIn className="w-4 h-4" /> Sign in <ChevronDown className="w-3.5 h-3.5" />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-56 bg-[#0F1E2C] border border-[#FFD166]/30 rounded-xl shadow-2xl overflow-hidden z-50" data-testid="login-menu-dropdown">
          <button onClick={() => { setOpen(false); nav("/login?role=customer"); }} className="w-full text-left px-4 py-3 text-sm text-[#F6F1E4] hover:bg-[#FFD166]/10 flex items-center gap-3" data-testid="login-menu-customer">
            <Users className="w-4 h-4 text-[#FFD166]" />
            <div><div>Customer Login</div><div className="text-[10px] text-[#B9C8D5]">Track your bookings</div></div>
          </button>
          <button onClick={() => { setOpen(false); nav("/login?role=employee"); }} className="w-full text-left px-4 py-3 text-sm text-[#F6F1E4] hover:bg-[#FFD166]/10 flex items-center gap-3 border-t border-[#FFD166]/10" data-testid="login-menu-employee">
            <Truck className="w-4 h-4 text-[#FFD166]" />
            <div><div>Employee Login</div><div className="text-[10px] text-[#B9C8D5]">Delivery driver portal</div></div>
          </button>
          <button onClick={() => { setOpen(false); nav("/login?role=admin"); }} className="w-full text-left px-4 py-3 text-sm text-[#F6F1E4] hover:bg-[#FFD166]/10 flex items-center gap-3 border-t border-[#FFD166]/10" data-testid="login-menu-admin">
            <Shield className="w-4 h-4 text-[#FFD166]" />
            <div><div>Admin Login</div><div className="text-[10px] text-[#B9C8D5]">Back office</div></div>
          </button>
        </div>
      )}
    </div>
  );
};
